export default function Header({
  headerData,
}: {
  headerData: { title: string; description: string };
}) {
  return (
    <div className="w-full px-[14px] md:px-[24px] lg:px-[48px] pb-[24px]  box-border">
      <div className="mb-[16px] md:mb-[24px]">
        <h2 className="text-[24px] md:text-[28px] lg:text-[32px] font-bb leading-[29px] md:leading-[34px] lg:leading-[39px] text-center mb-[16px] md:mb-[20px]">
          {headerData.title}
        </h2>
        <h5 className="text-[14px] md:text-[0.8vw] font-br text-center">
          {headerData.description}
        </h5>
      </div>
    </div>
  );
}
